import $ from "jquery";
import CountDownTimer from "./ContentElements/CountDownTimer";
import LogoutButton from "./ContentElements/LogoutButton";
import TimeTableDayView from "./ContentElements/TimeTableDayView";
import EventCheckboxManager from "./ContentElements/Registration.js";
$(() => {
    CountDownTimer.mount();
    LogoutButton.mount();
    TimeTableDayView.mount('.timetable-day-view');
    // let t = new Date("2024-02-24T10:00:00+01:00");
    // console.log(t);
    EventCheckboxManager.mount('input[type="checkbox"][data-eventid]');
});
